module.exports = __webpack_public_path__ + "media/images/about-slider-img-06-1b20b54593fe6201eb78515f2f71359e.jpg";